import { useState } from "react";

export default function Spot({ params }) {
  const {
    horizonralDirection,
    horizonralValue,
    verticalDirection,
    verticalValue,
  } = params;

  const [active, setActive] = useState(false);

  const zoomIn = (e) => {
    let currentTarget = e.target;
    let currentMedia = currentTarget.nextElementSibling;

    let x = currentTarget.offsetLeft,
      y = currentTarget.offsetTop;

    if (active) {
      setActive(false);
      currentMedia.style.transform = "translate(0px, -0px) " + "scale(1)";
    } else {
      setActive(currentTarget);

      currentMedia.style.transform =
        "translate(-" + x + "px, -" + y + "px) " + "scale(2)";
    }
  };

  return (
    <>
      <button
        onClick={zoomIn}
        className="ob-hot-spot"
        style={{
          [horizonralDirection]: horizonralValue,
          [verticalDirection]: verticalValue,
        }}
      >
        {/* <div className="ob-inner"></div> */}
      </button>
    </>
  );
}
